import svgPaths from './svg-after-auth';
import ScoreChip from './ScoreChip';
import CourseCarousel from '../courses/CourseCarousel';
import type { CourseModule } from '../../types/course';

interface AuthenticatedExperienceProps {
  fullName: string;
  score: number;
  modules: CourseModule[];
  onStartModule: (module: CourseModule) => void;
  onToggleModuleLock: (module: CourseModule) => void;
  onGoHome: () => void;
}

function DecorativeShapeLeft() {
  return (
    <div className="absolute flex inset-[77.96%_-12.87%_-7.95%_57.6%] items-center justify-center">
      <div className="flex-none h-[247.574px] w-[207.591px]" style={{ transform: 'rotate(2.265deg) scaleY(-1)' }}>
        <div className="relative size-full">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 208 248">
            <g id="Group 2085662883">
              <path d={svgPaths.p2f0f500} fill="var(--fill-0, #FFB518)" />
              <path d={svgPaths.p4d0e300} fill="var(--fill-0, #DD4506)" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}

function RightAccent() {
  return (
    <div className="absolute h-[18px] left-[327px] top-[176px] w-[62px]">
      <div className="absolute inset-[-33.39%_-9.68%_-33.34%_-9.68%]">
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 74 30">
          <path d={svgPaths.p1644ed00} stroke="var(--stroke-0, #FFB518)" strokeLinecap="round" strokeWidth="12" />
        </svg>
      </div>
    </div>
  );
}

function BottomRibbon() {
  return (
    <div className="absolute bottom-0 left-[-53px] h-[116px] w-[160px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 160 116">
        <g>
          <path d={svgPaths.p28c48d70} fill="var(--fill-0, #F55B1D)" />
          <path d={svgPaths.pffb4380} fill="var(--fill-0, #221F1F)" />
        </g>
      </svg>
    </div>
  );
}

const AuthenticatedExperience: React.FC<AuthenticatedExperienceProps> = ({
  fullName,
  score,
  modules,
  onStartModule,
  onToggleModuleLock,
  onGoHome,
}) => {
  return (
    <div className="figma-import bg-[#f6f5ec] relative size-full" data-name="Authentification 00">
      <DecorativeShapeLeft />
      <div
        className="absolute flex flex-col font-['Fredoka:SemiBold',_sans-serif] font-semibold justify-center leading-[0] left-[21px] text-[32px] text-black top-[201px] translate-y-[-50%] w-[254px]"
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        <p className="leading-none">Ton Quiz Formation Unkonito Expert</p>
      </div>
      <RightAccent />
      <BottomRibbon />
      <div className="auth-user-chip">
        <span className="auth-user-chip__avatar" aria-hidden="true" />
        <span className="auth-user-chip__name" dir="auto">
          {fullName}
        </span>
      </div>
      <ScoreChip score={score} />
      <CourseCarousel
        modules={modules}
        onStart={onStartModule}
        onToggleLock={onToggleModuleLock}
        onGoHome={onGoHome}
      />
    </div>
  );
};

export default AuthenticatedExperience;
